import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Courses from "./pages/Courses";
import Partners from "./pages/Partners";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";
import Dashboard from "./pages/Dashboard";
import { getDashboardUrl, isValidDashboardUrl } from "./utils/dashboardUrl";

// Component to handle dashboard routing
function DashboardRoute() {
  const location = useLocation();
  const expectedUrl = getDashboardUrl();
  
  // Only handle admin routes
  if (location.pathname.startsWith('/admin')) {
    // Check if current path matches today's date pattern
    if (isValidDashboardUrl(location.pathname)) {
      return <Dashboard />;
    }
    
    // Redirect to correct URL with today's date
    return <Navigate to={expectedUrl} replace />;
  }
  
  // For non-admin routes, redirect to home
  return <Navigate to="/" replace />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Main app routes with Header/Footer */}
          <Route path="/" element={
            <>
              <Header />
              <main>
                <Home />
              </main>
              <Footer />
            </>
          } />
          <Route path="/about" element={
            <>
              <Header />
              <main>
                <About />
              </main>
              <Footer />
            </>
          } />
          <Route path="/courses" element={
            <>
              <Header />
              <main>
                <Courses />
              </main>
              <Footer />
            </>
          } />
          <Route path="/partners" element={
            <>
              <Header />
              <main>
                <Partners />
              </main>
              <Footer />
            </>
          } />
          <Route path="/gallery" element={
            <>
              <Header />
              <main>
                <Gallery />
              </main>
              <Footer />
            </>
          } />
          <Route path="/contact" element={
            <>
              <Header />
              <main>
                <Contact />
              </main>
              <Footer />
            </>
          } />
          
          {/* Dashboard with dynamic date protection - must be last to catch admin routes */}
          <Route path="*" element={<DashboardRoute />} />
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
